<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

  import {
    Swiper,
    SwiperSlide,
    directive
  } from "vue-awesome-swiper";
  import "swiper/css/swiper.css";
  export default {
    name: 'App',
    components: {
      SwiperSlide,
      Swiper
    },
    directives: {
      swiper: directive,
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
  }

</script>

<style src="@/css/common.css">
body{
  margin: 0 !important;
}
  #app {
    /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    padding: 0;
    margin: 0;
  }

  body {
    margin: 0;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue